import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross Blue Shield of Massachusetts",
  shortName: "Blue Cross MA",
  slug: "blue-cross-ma-insurance",
  seoTitle:
    "Blue Cross Blue Shield of Massachusetts TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross Blue Shield of Massachusetts policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Blue Cross MA TMS coverage, Blue Cross Blue Shield Massachusetts SPRAVATO authorization, Blue Cross MA mental health benefits Coral Springs FL, Blue Cross Massachusetts depression treatment Florida",
};

export const BlueCrossMaInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default BlueCrossMaInsurance;
